import React, { Component } from 'react'
import { connect } from 'react-redux';
import config from '../../config';
import '../../css/responsive.css';
import { DISPATCH_ID } from '../../libs/utils/Const';
import { NavBar, BreadCumb, TimeOut, SettingsBot } from '../../components';

class AdminBot extends Component {

    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            viewTab: 1,
        }
    }
    render() {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        // const { _user } = this.state
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));

        return (
            <div>
                <NavBar props={this.props} itemsDashboard={itemsDashboard} _user={this.state._user} />
                <TimeOut />
                <BreadCumb subitem1={'BOT SETTINGS'} url1={'#'} />
                <div style={{ marginLeft: "5rem", marginRight: "1rem", marginBottom: "5rem" }}>
                    <div className="row h3 mb-3"> Settings </div>
                    <div className="row">
                        <div className='w-100'>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className={`nav-item nav-link font-weight-bold text-secondary ${this.state.viewTab === 1 ? 'active' : ''}`}
                                        id="nav-profile-tab-settingsRules"
                                        data-toggle="tab"
                                        href="#settingsRules"
                                        role="tab"
                                        onClick={() => this.UpdateStateField('viewTab', 1)}
                                        aria-controls="settingsRules">
                                        Settings rules
                                    </a>


                                </div>
                            </nav>

                            <div className="tab-content border border-top-0 rounded-bottom p-3">
                                <div id="settingsRules" className={`tab-pane px-3 ${this.state.viewTab === 1 ? 'active' : ''}`} role="tabpanel" aria-labelledby="nav-profile-tab-settingsRules" >
                                    {this.state.viewTab === 1 &&
                                        <SettingsBot
                                            showAlert={showAlert}
                                            enableSpinner={enableSpinner}
                                        />
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminBot);

